import { createFileRoute, Outlet, notFound } from "@tanstack/react-router";
import { noindexHead } from "@/lib/seo";

export const Route = createFileRoute("/dev/_devLayout")({
  component: RouteComponent,
  head: () => noindexHead("Dev | Lutely"),
  beforeLoad: () => {
    const env = import.meta.env.VITE_LOGICAL_ENV;
    if (env !== "local" && env !== "dev") {
      throw notFound();
    }
  },
});

function RouteComponent() {
  return <Outlet />;
}
